import React, { Fragment, useEffect, useState } from "react";
import "./AssetList.scss";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Checkbox,
  OutlinedInput,
  InputAdornment,
  IconButton,
  // Tooltip,
} from "@mui/material";
import { Tooltip } from "antd";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import {
  businessUnitActionsService,
  fetchBusinessUnit,
  fetchBusinessUnits,
} from "../../services/orgService";
import { checkPermissions, dateParser, toastMessage } from "../../helper";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import TargetDetailedView from "../Target/TargetDetailedView";

import AssetDetailedView from "./AssetDetailedView";
import {
  assetActionsService,
  discardAssets,
  getAssetListService,
  getAssetService,
} from "../../services/assetService";
import { MODE } from "../../constants/enums";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import EmptyList from "../common/EmptyList";
import { emissionScopeService } from "../../services/emissionService";
import TableFilterSort from "../common/TableFilterSort";
import SkeletonLoader from "../common/Skeletons/TableSkeleton/TableSkeletonLoader";

const AssetList = () => {
  const { t, i18n } = useTranslation();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const currentBusinessUnit = useSelector(
    (state: any) => state.auth.currentBusinessUnit
  );
  const [assetsList, setAssetsList] = useState([] as any);
  const [mode, setMode] = useState(MODE.PLAIN);
  const [selectedCount, setSelectedCount] = useState(0);
  const [targetsCount, setTargetsCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [controller, setController] = useState<any>({
    page: 0,
    limit: 10,
    sortBy: null,
    sortOrder: null,
    filters: {},
    columns: {
      "Asset ID": {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      "Asset Name": {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      "Asset Type": {
        type: "number",
        hasSortBy: false,
        filterOptions: {
          Vehicle: {
            value: 1,
            selected: false,
          },
          Equipment: {
            value: 2,
            selected: false,
          },
          Building: {
            value: 3,
            selected: false,
          },
          Furniture: {
            value: 4,
            selected: false,
          },
        },
        filterName: "types",
      },
      "Asset Status": {
        type: "string",
        hasSortBy: false,
        filterOptions: {
          Active: {
            value: "Active",
            selected: false,
          },
          InActive: {
            value: "InActive",
            selected: false,
          },
        },
        filterName: "status",
      },
    },
  });
  const [openTableFilterSort, setOpenTableFilterSort] = useState(false);
  const [selectedColumnData, setSelectedColumnData] = useState<any>();
  const showAssetFilterOptions = (columnName: any) => {
    if (columnName in controller.columns) {
      let selectedColumnData = controller.columns[columnName];
      if (
        selectedColumnData.hasSortBy &&
        Object.keys(selectedColumnData?.filterOptions)?.length === 0
      ) {
        const filterController: any = {
          sortBy: columnName,
        };
        if (controller.sortBy === columnName) {
          filterController["sortOrder"] =
            controller.sortOrder === "ASC" ? "DESC" : "ASC";
        } else {
          filterController["sortOrder"] = "ASC";
        }
        handleFilterAndSort(filterController, true);
      } else {
        selectedColumnData["columnName"] = columnName;
        selectedColumnData["sortBy"] = controller.sortBy;
        selectedColumnData["sortOrder"] = controller.sortOrder;
        setSelectedColumnData(selectedColumnData);
        setOpenTableFilterSort(true);
      }
    }
  };
  const handleFilterAndSort = (filterController: any, directSort: boolean) => {
    const updatedController = {
      ...controller,
      page: 0,
    };
    if (filterController.sortBy && filterController.sortOrder) {
      updatedController.sortBy = filterController.sortBy;
      updatedController.sortOrder = filterController.sortOrder;
    }
    if (filterController.selectedFilters?.length) {
      updatedController.filters[selectedColumnData.columnName] =
        filterController.selectedFilters;
    } else if (
      !directSort &&
      selectedColumnData &&
      updatedController.filters[selectedColumnData.columnName]
    ) {
      delete updatedController.filters[selectedColumnData.columnName];
    }
    setController({ ...updatedController });
    setOpenTableFilterSort(false);
  };
  const [detailedSelectIndex, setDetailedSelectIndex] = useState(0);
  const [detailedSelectItem, setDetailedSelectItem] = useState({} as any);
  const [searchText, setSearchText] = useState("");
  const [categoryPreferences, setCategoryPreferences] = useState<any>([]);
  const [scope, setScope] = useState();
  const [categoryData, setCategoryData] = useState<any>([]);
  const [assetDetailedItem, setAssetDetailedItem] = useState<any>({});

  const onClickSearch = () => {
    const reqObj = {
      controller: controller,
      searchText: searchText,
    };
    getAssetListService(reqObj)
      .then((res: any) => {
        const data = res.data;
        // const assetsList = data.businessUnits; TOBEMODIFIED
        const assetsList = data;

        // [{name:"Bunit 1",incharge:"Smith",type:"Manufacturing",id:99,status:"In Active",registrationId:"WWJTTY"},{name:"Bunit 2",incharge:"Warner",type:"Design",id:98,status:"active",registrationId:"WWJTTY-A"},{name:"Bunit 3",incharge:"Warner",type:"Design",id:97,status:"active",registrationId:"WWJTTY-A"},{name:"Bunit 4",incharge:"Warner",type:"Design",id:96,status:"active",registrationId:"WWJTTY-c"},{name:"Bunit 5",incharge:"Warner",type:"Design",id:95,status:"active",registrationId:"WWJTTY-A"}];
        assetsList.map((eachUnit: any) => (eachUnit.selected = false));
        setAssetsList([...assetsList]);
        // setTargetsCount(data.total_count); TOBEMODIFIED
        setTargetsCount(assetsList?.length || 0);

        setDetailedSelectItem(() => assetsList[detailedSelectIndex]);
      })
      .catch((e: any) => {
        toastMessage(e.response.data.message, "error");
      });
  };

  const onClickCancel = () => {
    setSearchText("");
    const reqObj = {
      controller: controller,
      searchText: "",
    };
    setIsLoading(true);
    getAssetListService(reqObj)
      .then((res) => {
        const data = res.data;
        const assetsList = data.businessUnits;
        assetsList.map((eachUnit: any) => (eachUnit.selected = false));
        setAssetsList([...assetsList]);
        setTargetsCount(data.total_count);
        setDetailedSelectItem(() => assetsList[detailedSelectIndex]);
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  // Name  Incharge, Unit type ,Address ,Status ,Unit ID

  let cellColumns = ["Asset ID", "Asset Name", "Asset Type", "Asset Status"];
  //  "Address"
  const navigate = useNavigate();
  const addNewUnit = () => {
    const bunitList = localStorage.getItem("businessUnits");
    !bunitList?.length
      ? toastMessage("Create a facility first for creating an asset", "error")
      : navigate("/asset", {
          state: {
            categoryPreferences: categoryPreferences,
            scope: scope,
            categoryData: categoryData,
          },
        });
  };
  const onChangeSelected = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    console.log(e);
    let assetList: any = assetsList;
    assetList[index]["selected"] = e.target.checked;
    setSelectedCount(
      assetList.filter((eachUnit: any) => eachUnit.selected)?.length || 0
    );
    setAssetsList([...assetList]);
    e.stopPropagation();
    setDetailedSelectIndex(index);
  };

  const handlePageChange = (event: any, newPage: number) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setController({
      ...controller,
      limit: parseInt(event.target.value, 10),
      page: 0,
    });
  };
  const onSelectBunit = (e: any, index: number) => {
    setMode(MODE.SELECTED);
    setDetailedSelectIndex(index);
    setDetailedSelectItem(assetsList[index]);
  };
  const onClose = () => {
    setMode(MODE.PLAIN);
  };
  const handleCancel = () => {
    let assetList: any = assetsList;
    assetList.forEach((element: any) => {
      element["selected"] = false;
    });
    setAssetsList([...assetList]);
    setSelectedCount(0);
  };
  // const handleDiscard = (disable?: any) => {
  //   console.log("all targets list", assetsList);

  //   let assetList: any = assetsList
  //     .filter((eachUnit: any) => eachUnit.selected)
  //     .map((Unit: any) => Unit.id.toString());
  //   console.log("selected targets list", assetList);
  //   const bunitStr = assetList.reduce(
  //     (prevVal: string, currVal: string, idx: number) => {
  //       return idx === 0 ? currVal : prevVal + ", " + currVal;
  //     },
  //     ""
  //   );
  //   const user = localStorage.getItem("userName");
  //   discardAssets({ assetIds: bunitStr, displayName: user })
  //     .then((res) => {
  //       console.log("res", res);
  //     })
  //     .then((res) => {
  //       setController({ ...controller, page: 0, limit: 10 });
  //       handleCancel();
  //     })
  //     .catch((e) => {
  //       toastMessage(e.response.data.message, "error");
  //       handleCancel();
  //     });
  //   // let assetList: any = assetsList;
  //   // assetList.forEach((element: any)=>{
  //   //     element["selected"] = false;
  //   // });
  //   // setAssetsList([...assetList]);
  //   // setSelectedCount(0);
  // };
  const handleAssetActions = (disable?: any) => {
    console.log("all assetsList actions", assetsList);

    let assetList: any = assetsList
      .filter((eachUnit: any) => eachUnit.selected)
      .map((Unit: any) => Unit.id.toString());
    console.log("selected bunits list", assetList);
    const assetStr = assetList.reduce(
      (prevVal: string, currVal: string, idx: number) => {
        return idx === 0 ? currVal : prevVal + ", " + currVal;
      },
      ""
    );
    assetActionsService({
      ids: assetStr,
      type: disable ? "disable" : "enable",
    })
      .then((res) => {
        setController({ ...controller, page: 0, limit: 10 });
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      });
    handleCancel();
  };
  const navigateNext = (increment: number, pageIncrement: number) => {
    if (pageIncrement) {
      setController((prevState: any) => {
        return { ...prevState, page: prevState.page + pageIncrement };
      });
      setDetailedSelectIndex(() =>
        pageIncrement === -1 ? controller.limit - 1 : 0
      );
    } else if (increment) {
      // onSelectBunit(null,increment);
      setDetailedSelectItem(() => assetsList[detailedSelectIndex + increment]);
      setDetailedSelectIndex((prevIndex) => prevIndex + increment);
    }
  };

  const getScopeCategories = async () => {
    let prefData = (
      await fetchBusinessUnit(
        JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id
      )
    ).data;
    let catPreferences = prefData.categoryPreferences;
    setCategoryPreferences(catPreferences);
    emissionScopeService({
      categories: catPreferences
        .map(
          (eachPreference: any) =>
            eachPreference[
              localStorage.getItem("protocol") == "ghg"
                ? "ghgCategory"
                : "category"
            ]
        )
        .toString(),
    })
      .then((res) => {
        const allOptions: any = [];
        setScope(res?.data?.[0]?.scope || null);
        res.data.forEach((parentCategory: any) => {
          const childCategories = parentCategory.categories;
          const codeNamePairs = childCategories.map((childCategory: any) => ({
            name: childCategory.code + "-" + childCategory.name,
            id: childCategory.id,
            scope: parentCategory.scope,
          }));
          allOptions.push(...codeNamePairs);
        });
        setCategoryData(allOptions);
      })
      .catch((err) => {
        toastMessage(err?.response?.data?.message, "error");
      });
  };
  useEffect(() => {
    getScopeCategories();
  }, [currentBusinessUnit]);

  useEffect(() => {
    const reqObj: any = {
      controller: controller,
      filter: {},
    };

    if (Object.keys(controller?.filters).length > 0) {
      Object.entries(controller?.filters).forEach(
        ([filterKey, filterValues]: any) => {
          if (filterValues.length) {
            const filterName =
              controller.columns[filterKey]?.filterName || filterKey;
            let filterValuesString: string = filterValues?.join(",");
            if (filterName === "status") {
              filterValuesString = filterValuesString
                .replace("InActive", "true")
                .replace("Active", "false");
            }
            reqObj.filter[filterName] = filterValuesString;
          }
        }
      );
    }
    searchText !== "" && (reqObj.searchText = searchText);
    setIsLoading(true);
    getAssetListService(reqObj)
      .then((res) => {
        const data = res.data;
        const assetsList = data.assets;
        assetsList.map((eachUnit: any) => (eachUnit.selected = false));
        setAssetsList([...assetsList]);
        setTargetsCount(data.total_count);
        setDetailedSelectItem(() => assetsList[detailedSelectIndex]);
        setIsLoading(false);
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      });
  }, [controller, searchText, currentBusinessUnit]);

  useEffect(() => {
    detailedSelectItem?.id &&
      getAssetService({ id: detailedSelectItem.id })
        .then((res: any) => {
          let assetDetailedItem = res.data.asset;
          setAssetDetailedItem(assetDetailedItem);
        })
        .catch((err) => {
          console.log(err);
        });
  }, [detailedSelectItem]);

  useEffect(() => {
    setDetailedSelectItem(assetsList[detailedSelectIndex]);
  }, [detailedSelectIndex]);

  return (
    <Fragment>
      {!assetsList?.length &&
        searchText === "" &&
        !isLoading &&
        !Object.keys(controller.filters).length && (
          <div className="pw-empty-page flex flex-col h-100v w-full justify-center items-center gap-5">
            <img
              className="pw-no-items"
              src="assets/images/empty.png"
              alt=" "
            />
            <div>{t("Welcome to Assets")}</div>
            <div className="pw-bunit-desc">{t("Assetmessage")}</div>
            {checkPermissions(["CREATE_ASSET"], permissions) ? (
              <div className="pw-add-new-bunit" onClick={addNewUnit}>
                <AddBoxIcon className="pw-box-icon" /> <span>{t("New")}</span>
              </div>
            ) : (
              ""
            )}
          </div>
        )}

      {(assetsList?.length ||
        searchText !== "" ||
        isLoading ||
        Object.keys(controller.filters).length) &&
      mode === MODE.PLAIN ? (
        <div className="pw-blist-main overflow-y-auto h-full w-full">
          <div className="pw-blist-header w-full flex flex-row justify-between">
            {/* <FormControl  }} variant="outlined"> */}
            {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
            <OutlinedInput
              id="outlined-adornment-password "
              className="pw-search-field"
              placeholder={t("Search")}
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  onClickSearch();
                }
              }}
              endAdornment={
                <InputAdornment position="end">
                  {searchText === "" ? (
                    <IconButton onClick={onClickSearch} edge="end">
                      <SearchIcon />
                    </IconButton>
                  ) : (
                    <IconButton onClick={onClickCancel} edge="end">
                      <CloseIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
            {/* </FormControl>  */}
            {selectedCount === 0 ? (
              <>
                {checkPermissions(["CREATE_ASSET"], permissions) ? (
                  <div className="pw-add-new-bunit" onClick={addNewUnit}>
                    <AddBoxIcon className="pw-box-icon" />{" "}
                    <span>{t("New")}</span>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              // <div className="flex flex-row justify-end  gap-4 text-sm">
              //   <div
              //     className="pw-bunit-button-light pw-bunit-button-next bg-white "
              //     onClick={handleCancel}
              //   >
              //     Cancel
              //   </div>
              //   <div
              //     className="pw-bunit-button-light pw-bunit-button-next bg-white pw-text-color px-2"
              //     onClick={() => handleDiscard(true)}
              //   >
              //     Mark as Inactive
              //   </div>
              //   <div
              //     className="pw-bunit-button-light pw-bunit-button-next bg-white pw-text-color px-2"
              //     onClick={() => handleDiscard()}
              //   >
              //     Mark as Active
              //   </div>
              //   {selectedCount === 1 ? (
              //     <Fragment>
              //       <div
              //         className="pw-bunit-button-light pw-bunit-button-next bg-white"
              //         onClick={() =>
              //           navigate("target", {
              //             state: {
              //               id: assetsList?.find(
              //                 (eachUnit: any) => eachUnit.selected
              //               )?.id,
              //               isClone: true,
              //             },
              //           })
              //         }
              //       >
              //         Clone
              //       </div>
              //       <div
              //         className="pw-bunit-button-light pw-bunit-button-next bg-white"
              //         onClick={() =>
              //           navigate(
              //             "/organisation/facilityconfigurations/" +
              //               assetsList?.find(
              //                 (eachUnit: any) => eachUnit.selected
              //               )?.id,
              //             {
              //               state: {
              //                 id: assetsList?.find(
              //                   (eachUnit: any) => eachUnit.selected
              //                 )?.id,
              //                 isEdit: true,
              //               },
              //             }
              //           )
              //         }
              //       >
              //         Edit
              //       </div>
              //     </Fragment>
              //   ) : (
              //     ""
              //   )}
              // </div>
              <div className="flex flex-row justify-end  gap-4 text-sm">
                <div
                  className="pw-bunit-button-light pw-bunit-button-next bg-white pw-text-color px-2"
                  onClick={() => handleAssetActions(true)}
                >
                  Mark as Inactive
                </div>
                <div
                  className="pw-bunit-button-light pw-bunit-button-next bg-white pw-text-color px-2"
                  onClick={() => handleAssetActions()}
                >
                  Mark as Active
                </div>
                {selectedCount === 1 ? (
                  <div
                    className="pw-bunit-button-light pw-bunit-button-next bg-white pw-text-color px-2"
                    onClick={() =>
                      navigate("/asset/" + detailedSelectItem?.id, {
                        state: {
                          assetDetailedItem: assetDetailedItem,
                          categoryPreferences: categoryPreferences,
                          categoryData: categoryData,
                          scope: scope,
                        },
                      })
                    }
                  >
                    {t("Edit")}
                  </div>
                ) : (
                  ""
                )}

                <div
                  className="pw-bunit-button-light pw-bunit-button-next bg-white text-error-500 px-2"
                  onClick={handleCancel}
                >
                  {t("Cancel")}
                </div>
              </div>
            )}
          </div>
          {isLoading ? (
            <SkeletonLoader type="text" cells={cellColumns} />
          ) : (
            <Fragment>
              {assetsList?.length || Object.keys(controller.filters).length ? (
                <div className="h-70v pw-hide-scroll overflow-y-auto">
                  <Card>
                    <Table size="small">
                      <TableHead>
                        <TableRow className="h-14">
                          <TableCell className="bg-neutral-50">
                            {/* <Checkbox
                        checked={allSelected}
                        indeterminate={!allSelected && selectedCount>0}
                        onChange={(e:any)=>globalSelectChange(e)}
                      /> */}
                          </TableCell>

                          {cellColumns.map((eachCell: any, index) => (
                            <TableCell
                              key={index}
                              className={`bg-neutral-50 ${
                                controller.sortBy === eachCell ||
                                (controller.filters[eachCell] &&
                                  Object.keys(controller.filters[eachCell])
                                    ?.length)
                                  ? "!bg-neutral-200 cursor-pointer"
                                  : controller?.columns?.[eachCell] &&
                                    assetsList?.length
                                  ? "pw-head-asset-bg cursor-pointer"
                                  : ""
                              } pw-thead-list`}
                              id={eachCell + "-th"}
                              onClick={() => {
                                return assetsList?.length
                                  ? showAssetFilterOptions(eachCell)
                                  : Object.keys(controller.filters[eachCell])
                                      ?.length
                                  ? showAssetFilterOptions(eachCell)
                                  : "";
                              }}
                            >
                              <div className="flex flex-row items-center gap-1">
                                {
                                  <Tooltip
                                    title={`${
                                      assetsList?.length
                                        ? controller?.columns?.[eachCell] &&
                                          Object.keys(
                                            controller?.columns?.[eachCell]
                                              ?.filterOptions
                                          )?.length
                                          ? "Filter by " + eachCell
                                          : controller?.columns?.[eachCell]
                                              ?.hasSortBy
                                          ? "Sort by " + eachCell
                                          : ""
                                        : ""
                                    }`}
                                    arrow={false}
                                    placement="bottomLeft"
                                  >
                                    <div>{eachCell}</div>
                                  </Tooltip>
                                }

                                {eachCell != " " &&
                                  controller.sortBy === eachCell &&
                                  // <img
                                  //   src={
                                  //     controller.sortOrder === "ASC"
                                  //       ? "assets/icons/sort_alphabetical_ascending.svg"
                                  //       : "assets/icons/sort_alphabetical_descending.svg"
                                  //   }
                                  //   alt=""
                                  // />
                                  (controller.sortOrder === "ASC" ? (
                                    <Tooltip
                                      title={`${
                                        assetsList?.length
                                          ? "Ascending Order - Click to sort in descending order"
                                          : ""
                                      }`}
                                      placement="bottomLeft"
                                      arrow={false}
                                    >
                                      <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title="Descending Order - Click to sort in ascending order"
                                      placement="bottomLeft"
                                      arrow={false}
                                    >
                                      <ArrowDownwardIcon
                                        sx={{ fontSize: 16 }}
                                      />
                                    </Tooltip>
                                  ))}
                                {controller?.columns?.[eachCell] &&
                                Object.keys(
                                  controller?.columns?.[eachCell]?.filterOptions
                                )?.length ? (
                                  <img
                                    src="assets/icons/filter-variant.svg"
                                    alt=""
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {assetsList?.length ? (
                        <TableBody className="cursor-pointer">
                          {assetsList.map((eachAsset: any, index: number) => (
                            <TableRow
                              key={eachAsset.id}
                              onClick={(e) => onSelectBunit(e, index)}
                              className={` ${
                                eachAsset.selected
                                  ? "bg-primary-100"
                                  : "bg-white"
                              } h-14`}
                            >
                              <TableCell className="pw-bunit-padding pw-bunit-width">
                                {checkPermissions(
                                  ["UPDATE_MULTIPLE_ASSETS"],
                                  permissions
                                ) ? (
                                  <Checkbox
                                    checked={eachAsset.selected}
                                    onClick={(e: any) =>
                                      onChangeSelected(e, index)
                                    }
                                  />
                                ) : (
                                  ""
                                )}
                              </TableCell>
                              <TableCell className="pw-bunit-padding pw-bunit-width">
                                {" "}
                                {eachAsset.local_code}{" "}
                              </TableCell>
                              <TableCell className="pw-bunit-padding pw-bunit-width">
                                {" "}
                                {eachAsset.name}{" "}
                              </TableCell>
                              <TableCell className="pw-bunit-padding pw-bunit-width">
                                {" "}
                                {eachAsset.type}{" "}
                              </TableCell>
                              {/* <TableCell className="pw-bunit-padding pw-bunit-width">
                        {" "}
                        {eachAsset.status}{" "}
                      </TableCell> */}
                              <TableCell className="pw-bunit-padding pw-bunit-width">
                                {" "}
                                <span
                                  className={`${
                                    !eachAsset.disabled
                                      ? "text-primary font-medium	"
                                      : "text-neutral-500"
                                  }`}
                                >
                                  {eachAsset.disabled ? "InActive" : "Active"}{" "}
                                </span>{" "}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      ) : (
                        ""
                      )}
                    </Table>
                  </Card>
                  {!assetsList?.length ? (
                    <div className="flex justify-center items-center h-full bg-white">
                      No results found
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <EmptyList cellColumns={cellColumns} />
              )}
              {targetsCount >= 10 && (
                <TablePagination
                  component="div"
                  onPageChange={handlePageChange}
                  page={controller.page}
                  count={targetsCount}
                  rowsPerPage={controller.limit}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Fragment>
          )}
        </div>
      ) : (
        ""
      )}

      {(assetsList?.length || searchText !== "") && mode === MODE.SELECTED ? (
        <div className="pw-blist-main-selected  h-90v flex flex-row">
          <div className="flex flex-col w-1/3 bg-neutral-200 pw-width-side">
            <div className="h-full pw-select-side-list overflow-y-auto flex flex-col w-45 gap-px">
              <div className="flex flex-row justify-between pw-padding-side-2 gap-4">
                <OutlinedInput
                  id="outlined-adornment-password "
                  className="pw-search-field pw-search-field-2"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      onClickSearch();
                    }
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {searchText === "" ? (
                        <IconButton onClick={onClickSearch} edge="end">
                          <SearchIcon />
                        </IconButton>
                      ) : (
                        <IconButton onClick={onClickCancel} edge="end">
                          <CloseIcon />
                        </IconButton>
                      )}
                    </InputAdornment>
                  }
                />
                {checkPermissions(["CREATE_ASSET"], permissions) ? (
                  <div className="pw-add-new-bunit" onClick={addNewUnit}>
                    <AddBoxIcon className="pw-box-icon" />{" "}
                    <span>{t("New")}</span>
                  </div>
                ) : (
                  ""
                )}
              </div>

              {assetsList?.length ? (
                assetsList.map((eachAsset: any, index: number) => (
                  <div
                    className={`flex flex-row cursor-pointer pw-bunitlist-card ${
                      detailedSelectItem?.id === eachAsset.id
                        ? "bg-neutral-100"
                        : "bg-white"
                    }`}
                    key={eachAsset.id}
                    onClick={(e) => onSelectBunit(e, index)}
                  >
                    <div className="flex flex-col justify-center gap-2">
                      <div className="pw-bunit-name font-medium text-sm ">
                        {eachAsset.local_code}
                      </div>
                      <div className="pw-bunit-name font-medium text-sm ">
                        {eachAsset.type}
                      </div>
                      {/* <div className="pw-bunit-name font-medium text-sm ">
                      {
                        eachAsset.data.find(
                          (eachMetric: any) => eachMetric.type === "BASELINE"
                        )?.year
                      }
                    </div>
                    <div className="pw-bunit-name font-medium text-sm ">
                      {
                        eachAsset.data.find(
                          (eachMetric: any) => eachMetric.type === "NET ZERO"
                        )?.year
                      }
                    </div>
                    <div className="pw-bunit-incharge text-neutral-600 text-sm">
                      {dateParser(eachAsset?.last_modified_on)}
                    </div>
                    <div className="pw-bunit-incharge text-neutral-600 text-sm">
                      {eachAsset.last_modified_by_name || "-"}
                    </div> */}
                    </div>
                  </div>
                ))
              ) : (
                <EmptyList />
              )}
            </div>
            {targetsCount >= 10 ? (
              <TablePagination
                component="div"
                count={targetsCount}
                page={controller.page}
                colSpan={5}
                onPageChange={handlePageChange}
                rowsPerPage={controller.limit}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage=""
                className="flex flex-row justify-end"
              />
            ) : (
              ""
            )}
          </div>
          {assetsList?.length ? (
            <AssetDetailedView
              assetData={detailedSelectItem}
              currentIndex={detailedSelectIndex}
              controller={controller}
              //  total_count={bunitsCount}
              navigateNext={navigateNext}
              setController={setController}
              onClose={onClose}
              categoryPreferences={categoryPreferences}
              categoryData={categoryData}
              scope={scope}
            />
          ) : (
            <EmptyList detailedView={true} />
          )}
        </div>
      ) : (
        ""
      )}
      {openTableFilterSort && (
        <TableFilterSort
          selectedColumnData={selectedColumnData}
          openTableFilterSort={openTableFilterSort}
          setOpenTableFilterSort={setOpenTableFilterSort}
          handleFilterAndSort={handleFilterAndSort}
          filter={controller.filters}
        />
      )}
    </Fragment>
  );
};

export default AssetList;
